import React, { useEffect, useState } from "react";
import profilePic from "../../../assets/images/profile_user.png";
import { CSSProperties } from "react";
import { Col, Input, Label, Row } from "reactstrap";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { Btn } from "../../../AbstractElements";
import DatePicker from "react-datepicker";
import EditProfileModal from "./EditProfileModal";
import GlobalShimmer from "../../../utils/GlobalShimmer";
import { showToast } from "../../../utils/toastUtils";

const CustomDatepickerInput = React.forwardRef<HTMLInputElement, any>(
  ({ value, onClick, placeholder }, ref) => (
    <input
      onClick={onClick}
      ref={ref}
      value={value}
      readOnly
      placeholder={placeholder}
      style={{
        padding: "8px 12px",
        borderRadius: "8px",
        border: "1px solid #ccc",
        fontSize: "14px",
        width: "100%",
        outline: "none",
        backgroundColor: "transparent",
        cursor: "pointer",
        color: "inherit",
      }}
    />
  )
);

const defaultStyles: { [key: string]: CSSProperties } = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#e6f7f9",
    padding: "24px",
    borderRadius: "16px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    width: "100%",
    maxWidth: "100%",
    flex: "1 1 0",
    gap: "25px",
  },
  imageContainer: {
    width: "100px",
    height: "100px",
    overflow: "hidden",
    marginBottom: "16px",
  },
  editProfileButton: {
    position: "absolute",
    bottom: "50%",
    right: "20%",
    background: "#007bff",
    color: "#fff",
    padding: "2px 6px",
    fontSize: "10px",
    borderRadius: "4px",
    cursor: "pointer",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: '50%'
  },
  nameText: {
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
  },
  emailText: {
    fontSize: "14px",
    color: "#888",
    textAlign: "center",
    marginBottom: "16px",
  },
  detailsContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "16px",
    width: "100%",
  },
  detailItem: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    fontSize: "12px",
    color: "#888",
  },
  value: {
    fontSize: "14px",
    fontWeight: "500",
    wordWrap: 'break-word'
  },
  divider: {
    width: "5px",
    height: "50%",
    background: "repeating-linear-gradient(to bottom, #007bff, #007bff 5px, transparent 5px, transparent 10px)",
    margin: "116px  16px",
    alignSelf: "stretch",
  },
  imageOuterContainer: {
    display: "flex",
    flexDirection: "column",
    width: "25%",
    alignItems: "center",
    justifyContent: "center",
  },
 datePickerPopup: {
    position: 'absolute',
    zIndex: 9999,
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
    border: '1px solid #ddd',
    display: 'flex',
    flexDirection: 'column'
  },
  datePickerContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  closeButton: {
    marginTop: 'auto', // This pushes the button to the bottom
    padding: '4px 8px',
    backgroundColor: '#f5f5f5',
    border: '1px solid #ddd',
    borderRadius: '4px',
    cursor: 'pointer',
    alignSelf: 'flex-end' // Aligns button to the right
  }
};

interface EmployeeProfileCardProps {
  employeeData: { [key: string]: any };
  requiredFields: { [key: string]: string };
  customStyles?: { [key: string]: CSSProperties };
  showDivider?: boolean;
  profileEdit?: boolean;
  onChangeStatus?: (employeeId: number, status: boolean) => void;
  onChangeCanLogin?: (employeeId: number, canLogin: boolean) => void;
  onSubmitDOB?: (employeeId: number, dob: string) => void;
  onSubmitJoinDate?: (employeeId: number, joinDate: string) => void;
  onEditProfileClick?: (employeeData: any) => void;
  canEditDOB?: boolean;
  canEditJoinDate?: boolean;
  showStatusToggle?: boolean;
  media?:string;
  isloading?:boolean
}

const EmployeeProfileCard: React.FC<EmployeeProfileCardProps> = ({
  employeeData = {},
  requiredFields,
  customStyles = {},
  showDivider = false,
  profileEdit = false,
  onChangeCanLogin,
  onChangeStatus,
  onSubmitDOB,
  onSubmitJoinDate,
  onEditProfileClick,
  canEditDOB = false,
  canEditJoinDate = false,
  showStatusToggle = true,
  media,
  isloading=false
}) => {
  console.log('emloyeedata',employeeData)
  console.log('ISLOADING',isloading)
  const [isJoiningDate, setJoiningDate] = useState(employeeData.JoinDate || employeeData.JoiningDate);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dob, setDOB] = useState(employeeData.BirthDate);
  const [refresh, setRefresh] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [datePickerPosition, setDatePickerPosition] = useState({ top: 0, left: 0 });
  const [currentDateField, setCurrentDateField] = useState<"dob" | "joinDate">("dob");
  const [dobError, setDobError] = useState("");
const [joinDateError, setJoinDateError] = useState("");


  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const defaultData: { [key: string]: string } = {
    Name: "John Doe",
    EmployeeCode: "EMP123",
    Email: "johndoe@example.com",
    ProfilePicture: profilePic,
    UserName: "johndoe",
    Role: "Admin",
    Department: "IT",
    Location: "Mumbai",
    ResignDate: "",
  };

  const fieldsToShow = requiredFields
    ? Object.keys(requiredFields)
    : Object.keys(defaultData);

  const styles = { ...defaultStyles, ...customStyles };

  const transformedData = Object.fromEntries(
    fieldsToShow.map((key) => {
      const rawKey = requiredFields?.[key] || key;
      const value = employeeData[rawKey];

      const isEmpty = value === undefined || value === null || value === "";
      const isDateField = ["JoiningDate", "DateOfBirth"].includes(key);

      return [
        key,
        isEmpty
          ? isDateField
            ? null
            : defaultData[key] ?? "Not Available"
          : value,
      ];
    })
  );

  const [toggleState, setToggleState] = useState({
    CanLogin: false,
    Status: false,
  });

  useEffect(() => {
    setDOB(employeeData.BirthDate);
  }, [employeeData]);
    useEffect(() => {
    setJoiningDate(employeeData.JoinDate);
  }, [employeeData]);

  useEffect(() => {
    const toBool = (val: any) => val == 1 || val === true;
    setToggleState({
      CanLogin: toBool(transformedData.CanLogin),
      Status: toBool(transformedData.Status),
    });
  }, [transformedData.CanLogin, transformedData.Status]);

  const handleToggleChange = (fieldKey: "CanLogin" | "Status") => {
    const newValue = !toggleState[fieldKey];
    setToggleState((prev) => ({ ...prev, [fieldKey]: newValue }));

    const employeeId = employeeData?.EmployeeId;
    if (!employeeId) return;

    if (fieldKey === "CanLogin" && onChangeCanLogin) {
      onChangeCanLogin(employeeId, newValue);
    } else if (fieldKey === "Status" && onChangeStatus) {
      onChangeStatus(employeeId, newValue);
    }
  };

  const validateDateRelation = (dobValue: string | null, joinValue: string | null) => {
  let dobErr = "";
  let joinErr = "";

  if (dobValue && joinValue) {
    const dobDate = new Date(dobValue);
    const joinDate = new Date(joinValue);

    if (joinDate <= dobDate) {
      dobErr = "Birth date must be smaller than joining date.";
      joinErr = "Joining date must be greater than birth date.";
    }
  }

  setDobError(dobErr);
  setJoinDateError(joinErr);
};

  const handleDateFieldClick = (e: React.MouseEvent<HTMLParagraphElement>, field: "dob" | "joinDate") => {
    const rect = e.currentTarget.getBoundingClientRect();
    setDatePickerPosition({
      top: rect.bottom + window.scrollY + 5,
      left: rect.left + window.scrollX
    });
    setCurrentDateField(field);
    setShowDatePicker(true);
  };

  // const handleDateChange = (date: Date | null) => {
  //   if (date) {
  //     const formatted = date.toISOString().split("T")[0];
  //     if (currentDateField === "dob") {
  //       setDOB(formatted);
  //       validateDateRelation(formatted, isJoiningDate);
  //       if (onSubmitDOB && employeeData?.EmployeeId) {
  //         onSubmitDOB(employeeData.EmployeeId, formatted);
  //       }
  //     } else {
  //       setJoiningDate(formatted);
  //        validateDateRelation(dob, formatted);
  //       if (onSubmitJoinDate && employeeData?.EmployeeId) {
  //         onSubmitJoinDate(employeeData.EmployeeId, formatted);
  //       }
  //     }
  //   }
  //   setShowDatePicker(false);
  // };


const handleDateChange = (date: Date | null) => {
  if (!date) return;

  const formatted = date.toISOString().split("T")[0]; // yyyy-mm-dd

  if (currentDateField === "dob") {
    // Validation: DOB < JoiningDate
    if (isJoiningDate && new Date(formatted) >= new Date(isJoiningDate)) {
      showToast.warning("Birth date must be earlier than joining date.");
      return; // stop here, do not call API
    }

    setDOB(formatted);
    if (onSubmitDOB && employeeData?.EmployeeId) {
      onSubmitDOB(employeeData.EmployeeId, formatted);
    }
  } else {
    // Validation: JoiningDate > DOB
    if (dob && new Date(formatted) <= new Date(dob)) {
      showToast.warning("Joining date must be later than birth date.");
      return; // stop here, do not call API
    }

    setJoiningDate(formatted);
    if (onSubmitJoinDate && employeeData?.EmployeeId) {
      onSubmitJoinDate(employeeData.EmployeeId, formatted);
    }
  }

  setShowDatePicker(false);
};



  const formatDate = (dateString: string | null) => {
  if (!dateString) return "Not Available";
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "Invalid Date";
    
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}-${month}-${year}`;
  } catch {
    return "Invalid Date";
  }
};

  const BASE_URL = "https://tspc-development.truesales.in/media?id=";

  return (
    <div style={styles.container}>
      {  !isloading ?<div style={{ ...styles.imageOuterContainer, position: "relative" }}>
        <div style={{ ...styles.imageContainer, position: 'relative' }}>
        <img
  src={media ? `${BASE_URL}${media}` : profilePic}
  alt="Profile"
  style={styles.image}
  onError={(e) => {
    (e.target as HTMLImageElement).src = profilePic; // Fallback to default image if error
  }}
/>
          {profileEdit && (
            <div
              style={{ ...styles.editProfileButton, bottom: '8%', right: '6%' }}
              onClick={() => {
                if (onEditProfileClick) {
                  onEditProfileClick(employeeData);
                } else {
                  toggleModal();
                }
              }}
            >
              Edit
            </div>
          )}
        </div>

        <p style={styles.nameText}>
          {transformedData.Name} | {transformedData.EmployeeCode}
        </p>
        <p style={styles.emailText}>{transformedData.Email}</p>
      </div>:<GlobalShimmer  height="30vh" shape="circle" style={{borderRadius:'50%',width:'40%'}} />}

      {showDivider && <div className="divider" style={styles.divider}></div>}

{!isloading ? (
  <>
    <div style={styles.detailsContainer}>
      {Object.entries(transformedData)
        .filter(
          ([key]) =>
            !["Name", "EmployeeCode", "Email", "ProfilePicture"].includes(key)
        )
        .map(([key, value]) => (
          <div key={key} style={styles.detailItem}>
            <p style={styles.label}>
              {key.replace(/([A-Z])/g, " $1").trim()}
            </p>
            {key === "JoiningDate" ? (
              canEditJoinDate ? (
                <p
                  onClick={(e) => handleDateFieldClick(e, "joinDate")}
                  style={{
                    ...styles.value,
                    color: "#007bff",
                    cursor: "pointer",
                  }}
                >
                  {formatDate(isJoiningDate) || "Not Available"}
               
                </p>
              ) : (
                <p style={styles.value}>
                  {String(value) || "Not Available"}
                </p>
              )
            ) : key === "DateOfBirth" ? (
              canEditDOB ? (
                <p
                  onClick={(e) => handleDateFieldClick(e, "dob")}
                  style={{
                    ...styles.value,
                    color: "#007bff",
                    cursor: "pointer",
                  }}
                >
                  {formatDate(dob) || "Not Available"}
                
                </p>
              ) : (
                <p style={styles.value}>
                  {String(value) || "Not Available"}
                </p>
              )
            ) : (key === "CanLogin" || key === "Status") &&
              showStatusToggle ? (
              <div className="form-check form-switch">
                <Input
                  type="switch"
                  checked={toggleState[key]}
                  onChange={() =>
                    handleToggleChange(key as "CanLogin" | "Status")
                  }
                  style={{ minHeight: "1.5em", width: "3em" }}
                />
              </div>
            ) : (
              <p style={styles.value}>
                {String(value) || "Not Available"}
              </p>
            )}
          </div>
        ))}
    </div>

    {showDatePicker && (
      <div
        style={{
          ...styles.datePickerPopup,
          top: datePickerPosition.top,
          left: datePickerPosition.left,
        }}
      >
        <div style={styles.datePickerContent}>
          <DatePicker
            selected={
              currentDateField === "dob"
                ? dob && !isNaN(new Date(dob).getTime())
                  ? new Date(dob)
                  : null
                : isJoiningDate &&
                  !isNaN(new Date(isJoiningDate).getTime())
                ? new Date(isJoiningDate)
                : null
            }
            onChange={handleDateChange}
            inline
            maxDate={new Date()}
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            dateFormat="dd-MM-yyyy"
          />
          <button
            onClick={() => setShowDatePicker(false)}
            style={styles.closeButton}
          >
            Close
          </button>
        </div>
      </div>
    )}
  </>
) : (
 <Row style={{marginRight:0,marginLeft:0}}>
  {Array.from({ length: 12 }).map((_, idx) => (
    <Col md="4" sm="3" xs="3"  style={{ paddingLeft: "4px", paddingRight: "4px" }} className="mb-3 mt-3" key={idx}>
      <GlobalShimmer width="150px" height="20px" style={{gap:2}} />
    </Col>
  ))}
</Row>
)}


      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={"Edit Profile"}
        size="xl"
        content={
          <EditProfileModal
            employeeProfileData={employeeData}
            toggle={toggleModal}
            refresh={refresh}
            setRefresh={setRefresh}
            mode='edit'
          />
        }
      />
    </div>
  );
};

export default EmployeeProfileCard;